import {
  applySnapshot,
  castToSnapshot,
  getSnapshot,
  Instance,
  onSnapshot,
  types,
} from "mobx-state-tree";
import { createContext, useContext } from "react";
import { AcademicTerms, initialStateAcademicTerms } from "./AcademicTerms";
import {
  CalculationCost,
  initialStateCalculationCost,
} from "./CalculationCost";
import { Holidays, initialStateHolidays } from "./Holiday";
import { initialStateLanding, Landing } from "./Landing";
import { initialStateProfile, Profile } from "./Profile";
import { Payment, initialStatePayment } from "./Payment";
import { initialStatePostalCode, PostalCodes } from "./PostalCode";
import { initialStateRegister, Register } from "./Register";
import { initialSchedule, Schedules } from "./Schedule";
import { initialStateSchools, Schools } from "./Schools";
import { initialStatestudents, Students } from "./Students";
import { Assigment, initialStateAssigment } from "./Assigment";
import { initialStateOnProcess, OnProcess } from "./OnProcessPayment";
import {
  initialStateOutstandingPayment,
  OutstandingPayment,
} from "./Outstanding";
import { HistoryPayment, initialStateHistoryPayment } from "./HistoryPayment";
import { GlobalTime } from "./Time";
import {
  SchedulePermissions,
  initialSchedulePermission,
} from "./SchedulePermission";
import { initialStateInvoices, Invoices } from "./Invoices";
import { Childs, initialStateChilds } from "./Child";
import { Customers, initialStateCustomers } from "@store/Customers";
import { Renewal, initialStateRenewal } from "./Renewal";

const RootModel = types
  .model({
    landing: Landing,
    payment: Payment,
    register: Register,
    schools: Schools,
    academicTerms: AcademicTerms,
    holidays: Holidays,
    postalCodes: PostalCodes,
    students: Students,
    calculationCost: CalculationCost,
    schedules: Schedules,
    profile: Profile,
    assigment: Assigment,
    onProcess: OnProcess,
    outstandingPayment: OutstandingPayment,
    historyPayment: HistoryPayment,
    globalTime: GlobalTime,
    schedulePermissions: SchedulePermissions,
    Invoices: Invoices,
    childs: Childs,
    customers: Customers,
    renewal: Renewal,
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate: () => {
        initialState = getSnapshot(self);
      },
      reset: () => {
        applySnapshot(self, initialState);
      },
    };
  });

let initialState = RootModel.create({
  landing: initialStateLanding,
  payment: initialStatePayment,
  register: initialStateRegister,
  schools: initialStateSchools,
  academicTerms: initialStateAcademicTerms,
  holidays: initialStateHolidays,
  postalCodes: initialStatePostalCode,
  students: initialStatestudents,
  calculationCost: initialStateCalculationCost,
  schedules: initialSchedule,
  profile: initialStateProfile,
  assigment: initialStateAssigment,
  onProcess: initialStateOnProcess,
  outstandingPayment: initialStateOutstandingPayment,
  historyPayment: initialStateHistoryPayment,
  globalTime: {},
  schedulePermissions: initialSchedulePermission,
  Invoices: initialStateInvoices,
  childs: initialStateChilds,
  customers: initialStateCustomers,
  renewal: initialStateRenewal,
});

const isBrowser = typeof window !== "undefined";
if (isBrowser) {
  const data = sessionStorage.getItem("kaye-store");
  if (data) {
    const json = JSON.parse(data);
    if (RootModel.is(json)) {
      initialState = RootModel.create(json);
    }
  }
}

export const rootStore = initialState;

onSnapshot(rootStore, (snapshot) => {
  console.log("Snapshot: ", snapshot);
  sessionStorage.setItem("kaye-store", JSON.stringify(snapshot));
});

export type RootInstance = Instance<typeof RootModel>;
const RootStoreContext = createContext<null | RootInstance>(null);

export const { Provider } = RootStoreContext;
export function useMst() {
  const store = useContext(RootStoreContext);
  if (store === null) {
    throw new Error("Store cannot be null, please add a context provider");
  }
  return store;
}
